module.exports = __webpack_public_path__ + "7e1e7f5944c1cadd2ab541612321ba4e.svg";